import axios from 'axios'
import qs from 'qs'
import store from '@/store'

import { Loading, Message } from 'element-ui'

const host = process.env.NODE_ENV === 'development' ? 'https://api.yuanjian66.com/' : 'https://api.yuanjian66.com/'
// http://zonghoutai.com/
// https://testapi.yuanjian66.com/
// https://api.yuanjian66.com/

const api = host + 'api/'
const timeout = 500

export default {
  host: host,
  imageUploadUrl () {
    return api + 'upload/image'
  },
  imageUploadUrl2000 () {
    return api + 'upload/image?is_distinct=1'
  },
  fileUploadUrl () {
    return api + 'upload/file'
  },
  // 上传doc或者docx文件的接收url
  fileDocUploadUrl () {
    return api + 'upload/file_doc'
  },
  imageUploadBefore (file) {
    // console.log(file)
  },
  imageUploadHeaders () {
    return {
      'X-CSRF-TOKEN': store.state.permission.token
    }
  },
  async post (uri, params, success, failure, silent) {
    uri = api + uri
    let loading = silent ? {close: () => {}} : Loading.service({background: 'rgba(0, 0, 0, 0.5)'})
    let config = {
      headers: {
        'X-CSRF-TOKEN': store.state.permission.token
      }
    }
    await axios.post(uri, qs.stringify(params), config)
      .then(res => {
        if (!silent) {
          setTimeout(() => {
            loading.close()
          }, timeout)
        }
        res = res.data
        if (res.code === 30000) {
          store.commit('permission/REMOVE_TOKEN')
        } else if (res.code === 200) {
          if (undefined !== success) success(res)
        } else {
          if (undefined !== failure) failure(res)
          else Message.error(res.msg)
        }
      })
      .catch(error => {
        if (!silent) {
          setTimeout(() => {
            loading.close()
          }, timeout)
        }
        console.log(error)
        Message.error('接口交互异常')
      })
  },
  async post2 (uri, params, success, failure, silent) {
    uri = api + uri
    let loading = silent ? {close: () => {}} : Loading.service({background: 'rgba(0, 0, 0, 0.5)'})
    let config = {
      headers: {
        'X-CSRF-TOKEN': store.state.permission.token
      }
    }
    const result = await new Promise((resolve, reject) => {
      axios.post(uri, qs.stringify(params), config)
        .then(res => {
          if (!silent) {
            setTimeout(() => {
              loading.close()
            }, timeout)
          }
          res = res.data
          if (res.code === 30000) {
            store.commit('permission/REMOVE_TOKEN')
          } else if (res.code === 200) {
            if (undefined !== success) resolve(res)
          } else {
            if (undefined !== failure) reject(res)
            else Message.error(res.msg)
          }
        })
        .catch(error => {
          if (!silent) {
            setTimeout(() => {
              loading.close()
            }, timeout)
          }
          console.log(error)
          Message.error('接口交互异常')
        })
    })
    return result
  },
  async image (file, success, failure, silent) {
    let uri = api + '/upload/image'
    let loading = silent ? {close: () => {}} : Loading.service({background: 'rgba(0, 0, 0, 0.5)'})
    let config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        'X-CSRF-TOKEN': store.state.permission.token
      }
    }
    let form = new FormData()
    form.append('image', file, file.name)
    await axios.post(uri, form, config)
      .then(res => {
        if (!silent) {
          setTimeout(() => {
            loading.close()
          }, timeout)
        }
        res = res.data
        if (res.code === 30000) {
          store.commit('permission/REMOVE_TOKEN')
        } else if (res.code === 200) {
          if (undefined !== success) success(res)
        } else {
          if (undefined !== failure) failure(res)
          else Message.error(res.msg)
        }
      })
      .catch(error => {
        if (!silent) {
          setTimeout(() => {
            loading.close()
          }, timeout)
        }
        console.log(error)
        Message.error('接口交互异常')
      })
  },
  async upload (uri, params, success, failure, silent) {
    uri = api + uri
    let loading = silent ? {close: () => {}} : Loading.service({background: 'rgba(0, 0, 0, 0.5)'})
    let config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        'X-CSRF-TOKEN': store.state.permission.token
      }
    }
    await axios.post(uri, params, config)
      .then(res => {
        if (!silent) {
          setTimeout(() => {
            loading.close()
          }, timeout)
        }
        res = res.data
        if (res.code === 30000) {
          store.commit('permission/REMOVE_TOKEN')
        } else if (res.code === 200) {
          if (undefined !== success) success(res)
        } else {
          if (undefined !== failure) failure(res)
          else Message.error(res.msg)
        }
      })
      .catch(error => {
        if (!silent) {
          setTimeout(() => {
            loading.close()
          }, timeout)
        }
        console.log(error)
        Message.error('接口交互异常')
      })
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js